
















































import Component, { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import ShowContainer from '@/common/mixin/ShowContainer';
import DetailRow from '@/common/component/DetailRow.vue';
import { facilityApi } from '@/context/facility/api/FacilityApi';
import { FacilityShowModel } from '@/context/facility/model/FacilityShowModel';
// import { notNullOrUndefined } from "@/utility/functions";
// import CustomerShowContainer from "@/context/customer/container/CustomerShowContainer.vue";
import { customerRouter } from '@/context/customer/router/CustomerRouter';
import ProgressSpinnerWrapper from '@/common/component/ProgressSpinnerWrapper.vue';

@Component({
  components: {
    ProgressSpinnerWrapper,
    // CustomerShowContainer,
    DetailRow
  }
})
export default class FacilityShowContainer extends mixins(ShowContainer) {
  model!: FacilityShowModel;

  async fetch(id: number): Promise<void> {
    const response: AxiosResponse = await facilityApi.show(id);
    this.model = response?.data?.view;
  }

  // get customerFetchable(): boolean {
  //   const result: boolean = notNullOrUndefined(this.model.customer);
  //   return result;
  // }

  get customerRoute(): Record<string, unknown> | null {
    return this?.model?.customer ? customerRouter.show(this.model.customer) : null;
  }

  get customerLabel(): string {
    return this.model.customer ? "Przejdź do detali" : "";
  }
}
